"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processHeadingMutations = processHeadingMutations;
var _rdflib = require("rdflib");
var _solidUi = require("solid-ui");
var _rdfMutationHelpers = require("../shared/rdfMutationHelpers");
var _idNodeFactory = require("../shared/idNodeFactory");
var _texts = require("../../texts");
function buildPhoneStatements(subject, doc, node, phone) {
  const normalizedValue = phone.value.startsWith('tel:') ? phone.value : `tel:${phone.value}`;
  const valueNode = (0, _rdflib.sym)(normalizedValue);
  const inserts = [(0, _rdflib.st)(subject, _solidUi.ns.vcard('hasTelephone'), node, doc), (0, _rdflib.st)(node, _solidUi.ns.vcard('value'), valueNode, doc)];
  if (phone.type) {
    inserts.push((0, _rdflib.st)(node, _solidUi.ns.rdf('type'), _solidUi.ns.vcard(phone.type), doc));
  }
  return inserts;
}
function buildEmailStatements(subject, doc, node, email) {
  const normalizedValue = email.value.startsWith('mailto:') ? email.value : `mailto:${email.value}`;
  const valueNode = (0, _rdflib.sym)(normalizedValue);
  const inserts = [(0, _rdflib.st)(subject, _solidUi.ns.vcard('hasEmail'), node, doc), (0, _rdflib.st)(node, _solidUi.ns.vcard('value'), valueNode, doc)];
  if (email.type) {
    inserts.push((0, _rdflib.st)(node, _solidUi.ns.rdf('type'), _solidUi.ns.vcard(email.type), doc));
  }
  return inserts;
}
function buildAddressStatements(subject, doc, node, address) {
  const inserts = [(0, _rdflib.st)(subject, _solidUi.ns.vcard('hasAddress'), node, doc)];
  if (address.type) inserts.push((0, _rdflib.st)(node, _solidUi.ns.rdf('type'), _solidUi.ns.vcard(address.type), doc));
  if (address.streetAddress) inserts.push((0, _rdflib.st)(node, _solidUi.ns.vcard('street-address'), address.streetAddress, doc));
  if (address.locality) inserts.push((0, _rdflib.st)(node, _solidUi.ns.vcard('locality'), address.locality, doc));
  if (address.region) inserts.push((0, _rdflib.st)(node, _solidUi.ns.vcard('region'), address.region, doc));
  if (address.postalCode) inserts.push((0, _rdflib.st)(node, _solidUi.ns.vcard('postal-code'), address.postalCode, doc));
  if (address.countryName) inserts.push((0, _rdflib.st)(node, _solidUi.ns.vcard('country-name'), address.countryName, doc));
  return inserts;
}
function findOpWithExistingEntry(ops, existingNodes) {
  return ops.find(op => Boolean(op.entryNode) && Boolean((0, _rdfMutationHelpers.findExistingNode)(existingNodes, op.entryNode)));
}
function findCreateOp(ops) {
  return ops.find(op => !op.entryNode);
}
async function mutatePhoneEntry(store, subject, phoneOps) {
  const doc = subject.doc();
  const existingPhoneNodes = store.each(subject, _solidUi.ns.vcard('hasTelephone'), null, doc);
  const deletions = [];
  const insertions = [];
  const removePhone = findOpWithExistingEntry(phoneOps.remove, existingPhoneNodes);
  const updatePhone = findOpWithExistingEntry(phoneOps.update, existingPhoneNodes);
  const createPhone = findCreateOp(phoneOps.create) || phoneOps.create[0];
  if (removePhone?.entryNode) {
    const existingNode = (0, _rdfMutationHelpers.findExistingNode)(existingPhoneNodes, removePhone.entryNode);
    if (existingNode) {
      const linkedPhoneStatements = (0, _rdfMutationHelpers.collectLinkedNodeStatements)(store, subject, _solidUi.ns.vcard('hasTelephone'), doc);
      const matchingLinkStatement = linkedPhoneStatements.linkStatements.find(statement => statement.object?.value === existingNode.value);
      if (matchingLinkStatement) {
        deletions.push(matchingLinkStatement);
      }
      deletions.push(...(0, _rdfMutationHelpers.collectNodeStatements)(store, existingNode, doc));
    }
  }
  if (updatePhone) {
    const existingNode = (0, _rdfMutationHelpers.findExistingNode)(existingPhoneNodes, updatePhone.entryNode);
    if (existingNode) {
      deletions.push(...(0, _rdfMutationHelpers.collectNodeStatements)(store, existingNode, doc));
      insertions.push(...buildPhoneStatements(subject, doc, existingNode, updatePhone));
    }
  }
  if (createPhone) {
    insertions.push(...buildPhoneStatements(subject, doc, (0, _idNodeFactory.createIdNode)(doc), createPhone));
  }
  await (0, _rdfMutationHelpers.applyUpdaterPatch)(store, deletions, insertions);
}
async function mutateEmailEntry(store, subject, emailOps) {
  const doc = subject.doc();
  const existingEmailNodes = store.each(subject, _solidUi.ns.vcard('hasEmail'), null, doc);
  const deletions = [];
  const insertions = [];
  const removeEmail = findOpWithExistingEntry(emailOps.remove, existingEmailNodes);
  const updateEmail = findOpWithExistingEntry(emailOps.update, existingEmailNodes);
  const createEmail = findCreateOp(emailOps.create) || emailOps.create[0];
  if (removeEmail?.entryNode) {
    const existingNode = (0, _rdfMutationHelpers.findExistingNode)(existingEmailNodes, removeEmail.entryNode);
    if (existingNode) {
      const linkedEmailStatements = (0, _rdfMutationHelpers.collectLinkedNodeStatements)(store, subject, _solidUi.ns.vcard('hasEmail'), doc);
      const matchingLinkStatement = linkedEmailStatements.linkStatements.find(statement => statement.object?.value === existingNode.value);
      if (matchingLinkStatement) {
        deletions.push(matchingLinkStatement);
      }
      deletions.push(...(0, _rdfMutationHelpers.collectNodeStatements)(store, existingNode, doc));
    }
  }
  if (updateEmail) {
    const existingNode = (0, _rdfMutationHelpers.findExistingNode)(existingEmailNodes, updateEmail.entryNode);
    if (existingNode) {
      deletions.push(...(0, _rdfMutationHelpers.collectNodeStatements)(store, existingNode, doc));
      insertions.push(...buildEmailStatements(subject, doc, existingNode, updateEmail));
    }
  }
  if (createEmail) {
    insertions.push(...buildEmailStatements(subject, doc, (0, _idNodeFactory.createIdNode)(doc), createEmail));
  }
  await (0, _rdfMutationHelpers.applyUpdaterPatch)(store, deletions, insertions);
}
async function mutateAddressEntry(store, subject, addressOps) {
  const doc = subject.doc();
  const existingAddressNodes = store.each(subject, _solidUi.ns.vcard('hasAddress'), null, doc);
  const deletions = [];
  const insertions = [];
  const removeAddress = findOpWithExistingEntry(addressOps.remove, existingAddressNodes);
  const updateAddress = findOpWithExistingEntry(addressOps.update, existingAddressNodes);
  const createAddress = findCreateOp(addressOps.create) || addressOps.create[0];
  if (removeAddress?.entryNode) {
    const existingNode = (0, _rdfMutationHelpers.findExistingNode)(existingAddressNodes, removeAddress.entryNode);
    if (existingNode) {
      const linkedAddressStatements = (0, _rdfMutationHelpers.collectLinkedNodeStatements)(store, subject, _solidUi.ns.vcard('hasAddress'), doc);
      const matchingLinkStatement = linkedAddressStatements.linkStatements.find(statement => statement.object?.value === existingNode.value);
      if (matchingLinkStatement) {
        deletions.push(matchingLinkStatement);
      }
      deletions.push(...(0, _rdfMutationHelpers.collectNodeStatements)(store, existingNode, doc));
    }
  }
  if (updateAddress) {
    const existingNode = (0, _rdfMutationHelpers.findExistingNode)(existingAddressNodes, updateAddress.entryNode);
    if (existingNode) {
      deletions.push(...(0, _rdfMutationHelpers.collectNodeStatements)(store, existingNode, doc));
      insertions.push(...buildAddressStatements(subject, doc, existingNode, updateAddress));
    }
  }
  if (createAddress) {
    insertions.push(...buildAddressStatements(subject, doc, (0, _idNodeFactory.createIdNode)(doc), createAddress));
  }
  await (0, _rdfMutationHelpers.applyUpdaterPatch)(store, deletions, insertions);
}
async function mutateBasicProfileEntry(store, subject, basicOps) {
  const doc = subject.doc();
  const deletions = [];
  const insertions = [];
  const replaceLiteralField = (predicate, value) => {
    const normalized = (value || '').trim();
    const nextObject = normalized ? (0, _rdflib.literal)(normalized) : null;
    (0, _rdfMutationHelpers.replacePredicateStatements)(store, subject, predicate, doc, deletions, insertions, nextObject);
  };
  const replacePhotoField = value => {
    const normalized = (value || '').trim();
    const nextObject = !normalized ? null : normalized.startsWith('http://') || normalized.startsWith('https://') ? (0, _rdflib.sym)(normalized) : (0, _rdflib.literal)(normalized);
    (0, _rdfMutationHelpers.replacePredicateStatements)(store, subject, _solidUi.ns.vcard('hasPhoto'), doc, deletions, insertions, nextObject);
  };
  const applyBasics = (basic, clearAll = false) => {
    const data = clearAll ? {
      name: '',
      nickname: '',
      dateOfBirth: '',
      jobTitle: '',
      orgName: '',
      imageSrc: ''
    } : basic;
    replaceLiteralField(_solidUi.ns.vcard('fn'), data.name);
    // Keep foaf:nick in sync where available in existing data.
    replaceLiteralField(_solidUi.ns.foaf('nick'), data.nickname);
    replaceLiteralField(_solidUi.ns.vcard('nickname'), data.nickname);
    replaceLiteralField(_solidUi.ns.vcard('bday'), data.dateOfBirth);
    replaceLiteralField(_solidUi.ns.vcard('role'), data.jobTitle);
    replaceLiteralField(_solidUi.ns.vcard('organization-name'), data.orgName);
    replacePhotoField(data.imageSrc);
  };
  const removeBasic = basicOps.remove[0];
  const updateBasic = basicOps.update[0];
  const createBasic = basicOps.create[0];
  const selectedBasic = updateBasic || createBasic || removeBasic;
  if (selectedBasic) {
    applyBasics(selectedBasic, Boolean(removeBasic && !updateBasic && !createBasic));
  }
  await (0, _rdfMutationHelpers.applyUpdaterPatch)(store, deletions, insertions);
}
async function processHeadingMutations(store, subject, mutationPlan) {
  try {
    await mutateBasicProfileEntry(store, subject, mutationPlan.basicOps);
    await mutatePhoneEntry(store, subject, mutationPlan.phoneOps);
    await mutateEmailEntry(store, subject, mutationPlan.emailOps);
    await mutateAddressEntry(store, subject, mutationPlan.addressOps);
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(`${_texts.saveHeadingUpdatesFailedPrefixText} ${message}`);
  }
}